import { gql } from "@apollo/client";

export const FETCH_DCDD_MEMBERSHIP = gql`
  query FetchDcddMembership {
    fetchDcddMembership {
        data {
            user_membership {
                created_at
                end_date
                id
                join_date
                membership_plan
                remarks
                status
                updated_at
                user_limit
            }
        }
        error {
            code
            field
            message
        }
    }
}
`;
